module.exports = __webpack_public_path__ + "static/media/Nad_sklepy.5f6872e4.md";